import React from 'react';
import { Box, SvgIcon } from '@material-ui/core';
import { iconPaths, IconTypes } from 'global/react/constants/icons';
import { colors } from 'global/react-mui/theme/colors';

type IconShape = 'default' | 'squared' | 'circle';

interface IconRendererPropsBase {
	shape?: IconShape;
	bgColor?: string;
	color?: string;
	svgStyle?: any;
	pathStyle?: any;
	boxProps?: any;
	size?: number;
	viewbox?: string;
	svgClassName?: string;
	boxClassName?: string;
	ariaLabel?: string;
}

interface IconRendererWithIcon extends IconRendererPropsBase {
	icon: IconTypes;
	path?: string;
}

interface IconRendererWithExtPath extends IconRendererPropsBase {
	path: string;
	icon?: IconTypes;
}

const getBoxBorderRadius = (shape: IconShape) => {
	if (shape === 'circle') return '50%';
	return 4;
};


const IconRenderer: React.FC<IconRendererWithIcon | IconRendererWithExtPath> = ({
	icon,
	path,
	shape = 'default',
	bgColor = 'transparent',
	color = colors['wolf-black'],
	size = 16,
	svgStyle = {},
	pathStyle = {},
	boxProps = {},
	svgClassName,
	boxClassName,
	ariaLabel,
	viewbox,
	...props
}) => {
	const enhancedSvgStyles = {
		width: size,
		height: size,
		margin: '4px',
		color,
		...svgStyle,
	};

	const enhancedBoxProps = {
		width: size * 1.5,
		height: size * 1.5,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: getBoxBorderRadius(shape),
		...boxProps,
	};

	return (
		<Box {...enhancedBoxProps} className={boxClassName} bgcolor={bgColor}>
			<SvgIcon aria-label={ariaLabel} style={enhancedSvgStyles} viewBox={viewbox} {...props}>
				{path ? <path style={pathStyle} d={path} /> : icon && <path style={pathStyle} d={iconPaths[icon]} />}
			</SvgIcon>
		</Box>
	);
};

export default IconRenderer;
